const {
	MAIN_EASING,
	DELAY_DEBOUNCE,
	CLASS_NO_DISPLAY,
} = require('../../../../js/consts');

const {
	getNumber,
	isFocusable,
	getFocusablesFrom,
} = require('../../../../js/functions');
let { breakMedium, breakLarge, mediumDelay } =
	require('../../../../js/sass-variables').default;

const { trackGtm, trackGtm4 } = require('../../../../js/functions');
const asyncImport = require('util/asyncImport').default;

breakMedium = getNumber(breakMedium);
breakLarge = getNumber(breakLarge);
mediumDelay = getNumber(mediumDelay);

module.exports = {
	async init() {
		this.articles = this.root.querySelectorAll(
			'.small-image-above-title, .gallery-item',
		);
		this.button = this.root.getElementsByClassName('unfoldable-list--more')[0];
		this.buttonText = this.button.innerHTML;
		this.hasFourColumns = this.root.classList.contains('four-columns');

		await asyncImport(this, ['anime', 'debounce']);

		this.displayCount = this.getMinimum();
		if (this.displayCount >= this.articles.length) {
			this.button.classList.add(CLASS_NO_DISPLAY);
		} else {
			this.update();
			this.button.addEventListener('click', e => {
				if (this.root.getAttribute('data-parent')) {
					trackGtm4({
						event: 'GA4_event_c_content_interaction',
						widget_name: this.root.getAttribute('data-parent'),
						widget_title: this.root.querySelector('.above-widget-title')
							.innerHTML,
						link_text: e.target.innerHTML.trim(),
						interaction_type: 'show more',
					});
				}
				const step = this.getStep();
				this.displayCount += step;
				this.update(step);
			});
		}
		this.track();
		window.addEventListener(
			'resize',
			this.debounce(this.resize.bind(this), DELAY_DEBOUNCE),
		);
		if (this.root.dataset.modal) this.initModals();
	},
	updateArticles(articlesList, number) {
		articlesList.forEach((article, i) => {
			article.style.display = i >= this.displayCount ? 'none' : '';
			if (i >= this.displayCount - number && i < this.displayCount) {
				article.classList.add('fade-in');
			}
		});
		if (number) {
			const firstNew = articlesList[this.displayCount - number];
			firstNew.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			});
			(isFocusable(firstNew)
				? firstNew
				: getFocusablesFrom(firstNew)[0]
			)?.focus();
		}
	},
	animateButton(buttonPosBefore) {
		const buttonPosAfter = this.button.getBoundingClientRect().bottom;
		const gap = buttonPosAfter - buttonPosBefore;
		this.button.classList.add('adding');

		this.anime({
			targets: this.button,
			top: [-gap, 0],
			duration: mediumDelay * 1000,
			easing: MAIN_EASING,
		}).finished.then(this.updateButtonVisibility.bind(this));
	},
	update(number = 0) {
		const buttonPosBefore = this.button.getBoundingClientRect().bottom;
		if (this.displayCount >= this.articles.length) {
			this.displayCount = this.articles.length;
		}

		const articlesList = Array.from(this.articles);
		this.updateArticles(articlesList, number);
		// update button label
		const leftArticles = this.articles.length - this.displayCount;
		this.button.innerHTML = `${this.buttonText} (${leftArticles})`;
		this.updateButtonVisibility();
		// button push animation
		if (number) {
			this.animateButton(buttonPosBefore);
		}
	},
	updateButtonVisibility() {
		// if some left or not
		if (this.displayCount < this.articles.length)
			this.button.classList.remove('adding');
		else {
			this.button.classList.add('deactivate');
		}
	},
	getMinimum() {
		let result = this.hasFourColumns ? 4 : 2;
		if (window.innerWidth >= breakMedium) result = this.hasFourColumns ? 5 : 3;
		if (window.innerWidth >= breakLarge) result = this.hasFourColumns ? 6 : 3;
		return result;
	},
	getStep() {
		let result = 4;
		if (window.innerWidth >= breakMedium) result = 3;
		if (window.innerWidth >= breakLarge) result = this.hasFourColumns ? 4 : 3;
		return result;
	},
	resize() {
		const initial = this.displayCount;
		const step = this.getStep();
		const min = this.getMinimum();
		// fix the number to have complete last row according to the new size steps
		if (this.displayCount < min) this.displayCount = min;
		const gap = (this.displayCount - min) % step;
		if (gap) this.displayCount += step - gap;
		if (this.displayCount !== initial) this.update(); // update only if changes
	},
	initModals() {
		this.modals = this.root.querySelectorAll('.modal-controller');
		this.smallImagesWidgets = this.root.querySelectorAll(
			'.small-image-above-title',
		);
		this.smallImagesWidgets.forEach((widget, index) => {
			widget.addEventListener('click', () =>
				this.modals[index].__controller.open(),
			);
		});
	},
	track() {
		const mainArticle = this.root.querySelector('.large-image-text-on-image');
		const otherArticles = this.root.querySelectorAll(
			'.small-image-above-title a',
		);
		const widgetName = this.root.getAttribute('data-parent');
		const widgetTitle = this.root.getAttribute('data-parent-title');
		if (mainArticle)
			mainArticle.addEventListener('click', _ => {
				const imageLink = mainArticle.querySelector(
					'.box-article-content--link',
				);
				trackGtm({
					eventCategory: 'cta',
					eventAction: 'read',
					eventLabel: mainArticle.href,
				});
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: widgetName,
					widget_title: widgetTitle,
					link_text: imageLink.innerHTML,
					link_url: imageLink.href,
					button_type: '',
				});
			});

		otherArticles.forEach(element => {
			element.addEventListener('click', _ => {
				trackGtm({
					eventCategory: 'cta',
					eventAction: 'image',
					eventLabel: element.href,
				});
			});
		});
	},
};
